/**
 * Seule erreur que le code métier a le droit de lever pour produire une
 * réponse HTTP maîtrisée (gérée centralement par `registerErrorHandling` dans
 * `errors.ts`).
 *
 * Isolée dans son propre fichier, sans aucune dépendance (ni Fastify, ni
 * Node) : les modules de règles métier du §4 CLAUDE.md (`adaptQuantities.ts`)
 * la lèvent aussi, et doivent rester importables tels quels par le client
 * (même principe que `parseIngredientLine`, cf. DECISIONS.md « US-01 »). Si
 * cette classe restait dans `errors.ts`, l'import entraînerait `config.ts`
 * (donc `node:fs`) dans le bundle du navigateur.
 */
export class AppError extends Error {
  constructor(
    readonly statusCode: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'AppError';
  }
}
